import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';

import {
    AuthorizationService,
    AttributeService,
    ToastrService,
    Attribute,
    AttributeMaps,
    DocumentPartMap,
    GlobalService
} from './../../../shared/index';

@Component({
    selector: 'codemanagement-index',
    templateUrl: './codemanagement-index.html',
    standalone: false
})

export class CodeManagementIndexComponent implements OnInit, OnDestroy {
    @ViewChild('mapManipulate') modal: ModalDirective
    public attributes: Attribute[] = [];

    public attribute: Attribute = new Attribute();
    public map: DocumentPartMap = new DocumentPartMap();

    private subscriptions: Subscription[] = [];

    public add = true;
    public filename: string;
    private files: File[];
    private shouldUpload = false;

    constructor(
        private _authorizationService: AuthorizationService,
        private _attributeService: AttributeService,
        private _toastrService: ToastrService,
        private _ngZone: NgZone,
        private _globalService: GlobalService
    ) {
        this.subscriptions.push(this._attributeService.attributesChange.subscribe((attributes: Attribute[]) => {
            this.attributes = attributes;
            for (const attribute of this.attributes) {
                attribute.Maps.init();
                this._attributeService.getMaps(attribute.Id);
            }
        }));
        this.subscriptions.push(this._attributeService.attributeMapChange.subscribe((attributeMaps: AttributeMaps) => {
            this._ngZone.run(() => {
                const attribute: Attribute = this.attributes.filter((value) => value.Id == attributeMaps.AttributeId)[0];
                attribute.Maps.init();
                for (const map of attributeMaps.Maps) {
                    attribute.Maps.update(map, true);
                }
            });
        }));
        this.subscriptions.push(this._globalService.deleteResult.subscribe((result: boolean) => {
            if (result) {
                this._attributeService.delete(this.map);
                this._attributeService.getMaps(this.map.AttributeId);
            }
        }));
    }

    public preUpload(event: any): void {
        this.files = event.srcElement.files;
        this.filename = this.files[0].name;
        this.shouldUpload = true;
    }

    public create(another: boolean = false): void {
        if (this.add) {
            this._attributeService.create(this.map);
            if (!another) {
                this._attributeService.getMaps(this.map.AttributeId);
                this.modal.hide();
                return;
            }

            this.map = new DocumentPartMap();
            this.map.AttributeId = this.attribute.Id;
            return;
        }

        this._attributeService.update(this.map);
        this.modal.hide();
        this._attributeService.getMaps(this.map.AttributeId);

        if (this.shouldUpload) {
            const formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();
            formData.append('suiteId', this.map.Id.toString());

            for (let i = 0; i < this.files.length; i++) {
                formData.append('uploads[]', this.files[i], this.files[i].name);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this._toastrService.displayToastrMessage('success', 'Suite logo uploaded for ' + this.map.Value + '!', 'Logo Upload');
                    } else {
                        this._toastrService.displayToastrMessage('error', 'Suite logo upload failed for ' + this.map.Value + '!', 'Logo Upload');
                    }
                    this.shouldUpload = false;
                    this.files = [];
                    this.filename = '';
                }
            };

            xhr.open('POST', window.document.location.origin + '/api/Manuals/UploadSuiteLogo', true);
            xhr.send(formData);
        }
    }

    public addMap(attribute: Attribute): void {
        this.add = true;
        this.attribute = attribute;
        this.map = new DocumentPartMap();
        this.map.AttributeId = attribute.Id;
        this.modal.show();
    }

    public editMap(map: DocumentPartMap, attribute: Attribute): void {
        this.add = false;
        this.map = map;
        this.attribute = attribute;
        this.modal.show();
    }

    public removeMap(map: DocumentPartMap): void {
        this.map = map;
        this._globalService.confirmDelete('document map', map.Part + ' to ' + map.Value, map.Id);
    }

    public close(): void {
        this._attributeService.getMaps(this.map.AttributeId);
        this.modal.hide();
    }

    ngOnInit(): void {
        this._attributeService.getAttributes();
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
